<template>
  <div class="comment__audit-compare-content comment__item-type-content">
    <BaseButton
      v-if="beforeType === 'RETROSPECTIVE_NOTE'"
      level="large"
      :padding="false"
      className=""
    >
      <icon
        data="@icon/retrospective.svg"
        class=""
        :fill="true"
        width="1.5em"
        height="1.5em"
      />

      Retrospective Note
    </BaseButton>
    <StatusComponent
      v-else
      :value="getItemTypeById(beforeType)"
      class="type"
    />
    <icon
      data="@icon/arrow-to.svg"
      :fill="true"
      width="var(--icon-24)"
      height="var(--icon-24)"
      color="var(--monochrome05to04)"
      class="add-bg"
    />
    <StatusComponent
      :value="getItemTypeById(afterType)"
      class="type"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"

import StatusComponent from "@/components/StatusComponent/index.vue"

import { Comment, typeCreateById } from "@/models"

const props = defineProps<{
  comment: Comment
}>()

const beforeType = computed(() => props.comment.before?.itemType ?? null)
const afterType = computed(() => props.comment.after?.itemType ?? null)

function getItemTypeById(id: string | null) {
  return typeCreateById({ id: id ?? "STORY" })
}
</script>
